/**
 * Lib.Common: View component declarations
 */


import ibApplication        from './ib-application.vue';
import ibBar                from './ib-bar.vue';
import ibDialog             from './ib-dialog.vue';
import ibDrawer             from './ib-drawer.vue';
import ibPopup              from './ib-popup.vue';

// soon to be deprecated:
import ibModal              from './ib-modal.vue';
import ibPane               from './ib-pane.vue';
import ibPopover            from './ib-popover.vue';
import ibPopover2           from './ib-popover2.vue';


export default [
    ibApplication,
    ibBar,
    ibDialog,
    ibDrawer,
    ibPopup,

    ibModal,
    ibPane,
    ibPopover,
    ibPopover2
];
